module.exports = __webpack_public_path__ + "static/img/ma9.ef4c19f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma9.gif
// module id = sn4W
// module chunks = 1